<template>
  <InfuseSlideInLayout :title="centralSystem?.name" :parent-to="{ name: 'central-systems' }">
    <template #header>
      <h1 class="text-xl font-bold text-neutral-700">
        <span>{{ centralSystem?.name }}</span>

        <InfuseTag v-if="centralSystem?.ocppVersion" :inline="true" class="ml-4 font-medium" variant="neutral">
          <font-awesome-icon :icon="['fal', 'signal-stream']" class="mr-2" />
          OCPP-{{ centralSystem?.ocppVersion }}
        </InfuseTag>

        <InfuseTag v-if="centralSystem?.type" :inline="true" class="ml-4 font-medium" variant="neutral">
          <font-awesome-icon :icon="['fal', 'ethernet']" class="mr-2" />
          {{ centralSystem?.type }}
        </InfuseTag>
      </h1>
    </template>

    <InfuseRouterTabLayout v-if="centralSystem" :model="centralSystem" @reload-model="refresh" />
    <InfuseSpinner v-else class="flex items-center justify-center p-16" size="medium" />
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { InfuseSpinner, InfuseTag } from '@infuse/ui/components';
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useCentralSystem } from '@infuse/e-connector/central-system/queries';
import { useRedirectOnNotFound } from '@infuse/e-connector/shared/composables';

const route = useRoute();
const id = computed(() => route.params.id?.toString());

const { centralSystem, fetchCentralSystemId, isError, error } = useCentralSystem();
useRedirectOnNotFound(isError, error);

watch(id, () => (fetchCentralSystemId.value = id.value), { immediate: true });

async function refresh() {
  fetchCentralSystemId.value = id.value;
}
</script>
